import {IPrice} from '../types/Show'
import {ILabel} from '../../../types'

export default {
    endingMessage(price: IPrice): ILabel {
        return <ILabel>{
            de: 'Alle zahlen nur '+price.text,
            fr: 'Tout a été vendu pour seulement '+price.text,
            it: 'Tutti pagano solo '+price.text,
            es: 'Todos pagan tan solo '+price.text,
            nl: 'Iedereen betaalt slechts '+price.text,
            en: 'Everyone pays '+price.text,
        }
    },
    cancelledMessage: <ILabel>{
        de: 'Stopp',
        fr: 'Arrêt',
        it: 'Fermare',
        es: 'Stop',
        nl: 'Stop',
        en: 'Stop',
    },
}